
import { BasicButton } from "@goodgamestudios/asset-globals";
import { MathBase } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { BasicComboboxEvent } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";
import { Poker2Constants } from "../../constants/Poker2Constants";
import { SFConstants } from "../../constants/SFConstants";
import { Balancing } from "../../constants/shared/Balancing";
import { GiftsVO } from "../../gamevo/GiftsVO";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2MouseWheelUpDown } from "../components/Poker2MouseWheelUpDown";
import { Poker2Dialog } from "./Poker2Dialog";
import { Poker2SendGiftDialogProperties } from "./Poker2SendGiftDialogProperties";

import { NumberStringHelper } from "../../helper/NumberStringHelper";

import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;
import Rectangle = createjs.Rectangle;

export class Poker2SendGiftDialog extends Poker2Dialog {
    public static NAME: string = "Poker2SendGiftDialog";

    private static SORT_NUMERIC: number = 0;
    private static SORT_DESCENDING: number = 1;
    private levelSortComboBox: Poker2DynamicCombobox;
    private sortType: number = Poker2SendGiftDialog.SORT_NUMERIC;

    private categoryButtons: any[];
    private itemButtons: any[];
    private mouseWheelUpDown: Poker2MouseWheelUpDown;

    private currentCategory: string;
    private currentPage: number = 0;
    private maxPage: number = 0;

    private ITEMS_PER_PAGE: number = 8;

    constructor(disp: Container) {
        CONSTRUCTOR_HACK;
        super(disp);
    }
    protected init(): void {
        super.init();

        this.shopScreen.bg.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);

        this.initComboBoxes();

        //
        this.categoryButtons = [this.shopScreen.btn_drink, this.shopScreen.btn_food, this.shopScreen.btn_extra];

        // check if an event is active. if not, don't show the event's tab
        if (Poker2Model.eventIsActive) {
            // Create a specific tab skin for the first event in the currentEvents array
            // Caution: It's possible that more than one event is active in the same time (hence, the existing events halloween, soccer and xmas might not
            // take place in the same time), but will always taken the first tab view.
            if (Poker2Model.sessionData.currentEvents && Poker2Model.sessionData.currentEvents[0]) {
                var eventBtnSkin: MovieClip;
                switch (Poker2Model.sessionData.currentEvents[0]) {
                    case "halloween":

                        eventBtnSkin = new Library.PokerInterface.Btn_EventGiftTab_halloween();
                        break;

                    case "xmas":

                        eventBtnSkin = new Library.PokerInterface.Btn_EventGiftTab_xmas();
                        break;
                }

                eventBtnSkin.x = -36.4;
                eventBtnSkin.y = -186.2;
                eventBtnSkin.name = "btn_event";
                eventBtnSkin.toolTipText = Poker2Model.languageData.getTextById("table_gifts_tab4_tooltip");
                this.shopScreen.addChild(eventBtnSkin);
                this.categoryButtons.push(eventBtnSkin);
            }
        }

        this.itemButtons = new Array();
        for (var i: number = 0; i < this.ITEMS_PER_PAGE; i++) {
            this.itemButtons.push(this.shopScreen.mc_shopitems["item" + i]);
        }

        this.initTextFields();

        // help button
        this.shopScreen.btn_help.toolTipText = Poker2Model.languageData.getTextById("dialog_giftshop_tooltip_help");

        this.mouseWheelUpDown = new Poker2MouseWheelUpDown();
        this.mouseWheelUpDown.init(this.shopScreen.btn_leftarrow, this.shopScreen.btn_rightarrow, this.shopScreen);
    }

    private initComboBoxes(): void {
        this.levelSortComboBox = new Poker2DynamicCombobox(this.shopScreen.combo_sort, "", 2);
        this.levelSortComboBox.addItem({ label: Poker2Model.languageData.getTextById("dialog_giftshop_combo_1") });
        this.levelSortComboBox.addItem({ label: Poker2Model.languageData.getTextById("dialog_giftshop_combo_0") });
        this.levelSortComboBox.defaultString = Poker2Model.languageData.getTextById("dialog_giftshop_combo_1");
    }

    private initTextFields(): void {
        this.shopScreen.txt_sort.text = Poker2Model.languageData.getTextById("shop_txt_sort");
        this.shopScreen.txt_title.text = Poker2Model.languageData.getTextById("table_gifts");
        this.shopScreen.btn_drink.toolTipText = Poker2Model.languageData.getTextById("table_gifts_tab1_tooltip");
        this.shopScreen.btn_food.toolTipText = Poker2Model.languageData.getTextById("table_gifts_tab2_tooltip");
        this.shopScreen.btn_extra.toolTipText = Poker2Model.languageData.getTextById("table_gifts_tab3_tooltip");
    }

    public show(): void {
        super.show();
        this.levelSortComboBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onLevelSortComboboxChange));
        this.sortType = Poker2SendGiftDialog.SORT_NUMERIC;
        this.changeCategory("drinks");
        this.fillItems();
        this.mouseWheelUpDown.activateMouseWheel();
    }

    public hide(): void {
        this.mouseWheelUpDown.deactivateMouseWheel();
        this.levelSortComboBox.disp.removeEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onLevelSortComboboxChange));
        super.hide();
    }

    public destroy(): void {
        super.destroy();
        this.mouseWheelUpDown.destroy();
    }

    private onLevelSortComboboxChange(event: BasicComboboxEvent): void {
        this.sortType = int(this.levelSortComboBox.selectedId);
        this.fillItems();
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        switch (event.target) {
            case this.shopScreen.btn_close:
                this.hide();
                break;
            case this.shopScreen.mc_shopitems.item0.btn_buy:
            case this.shopScreen.mc_shopitems.item1.btn_buy:
            case this.shopScreen.mc_shopitems.item2.btn_buy:
            case this.shopScreen.mc_shopitems.item3.btn_buy:
            case this.shopScreen.mc_shopitems.item4.btn_buy:
            case this.shopScreen.mc_shopitems.item5.btn_buy:
            case this.shopScreen.mc_shopitems.item6.btn_buy:
            case this.shopScreen.mc_shopitems.item7.btn_buy:
                this.buyOneItem(event.target.properties);
                break;
            case this.shopScreen.mc_shopitems.item0.btn_buyall:
            case this.shopScreen.mc_shopitems.item1.btn_buyall:
            case this.shopScreen.mc_shopitems.item2.btn_buyall:
            case this.shopScreen.mc_shopitems.item3.btn_buyall:
            case this.shopScreen.mc_shopitems.item4.btn_buyall:
            case this.shopScreen.mc_shopitems.item5.btn_buyall:
            case this.shopScreen.mc_shopitems.item6.btn_buyall:
            case this.shopScreen.mc_shopitems.item7.btn_buyall:
                this.buyAllItems(event.target.properties);
                break;
            case this.shopScreen.btn_drink:
                this.changeCategory("drinks");
                break;
            case this.shopScreen.btn_food:
                this.changeCategory("food");
                break;
            case this.shopScreen.btn_extra:
                this.changeCategory("extras");
                break;
            case this.shopScreen.btn_leftarrow:
            case this.shopScreen.btn_rightarrow:
                this.onClickArrow(event);
                break;
        }

        // check for runtime added event button
        if (event.target.name == "btn_event") {
            this.changeCategory("events");
        }
    }

    /*		private function isButtonInArray(button:BasicButton, array:Array):Boolean
            {
                if (button == null || array == null)
                    return false;

                for (var i:int=0; i<array.length; i++)
                {
                    if (button == array[i])
                        return true;
                }
                return false;
            }*/

    /**
     * Pfeil-Button initialisieren, je nach Anzahl an Items werden die Button angezeigt
     */
    private initArrows(nofItems: number): void {
        this.maxPage = int((nofItems - 1) / this.ITEMS_PER_PAGE);
        this.shopScreen.btn_rightarrow.visible = this.shopScreen.btn_leftarrow.visible = (this.maxPage > 0);
        this.shopScreen.btn_rightarrow.enableButton = (this.maxPage > 0 && this.currentPage < this.maxPage);
        this.shopScreen.btn_leftarrow.enableButton = (this.maxPage > 0 && this.currentPage > 0);
    }

    private onClickArrow(event: MouseEvent): void {
        var oldPage: number = this.currentPage;
        if (event.target == this.shopScreen.btn_leftarrow)
            this.currentPage = int(Math.max(0, this.currentPage - 1));
        else
            this.currentPage = int(Math.min(this.maxPage, this.currentPage + 1));
        if (oldPage != this.currentPage)
            this.fillItems();
    }

    private buyAllItems(currentGiftId: number): void {
        var paramObject: any = { giftId: currentGiftId, index: -1 };
        BasicModel.smartfoxClient.sendMessage("ggg", [JSON.stringify(paramObject)]);
        this.hide();
    }
    private buyOneItem(currentGiftId: number): void {
        var paramObject: any = { giftId: currentGiftId, index: this.shopProperties.seatId };
        BasicModel.smartfoxClient.sendMessage("ggg", [JSON.stringify(paramObject)]);
        this.hide();
    }

    private changeCategory(category: string): void {
        this.currentCategory = category;
        switch (this.currentCategory) {
            case "drinks":
                this.activateButton(this.shopScreen.btn_drink, this.categoryButtons);
                break;
            case "food":
                this.activateButton(this.shopScreen.btn_food, this.categoryButtons);
                break;
            case "extras":
                this.activateButton(this.shopScreen.btn_extra, this.categoryButtons);
                break;
            case "events":
                this.activateButton(((this.shopScreen.getChildByName("btn_event")) as BasicButton), this.categoryButtons);
                break;
        }
        this.currentPage = 0;
        this.fillItems();
    }

    private activateButton(selectedButton: BasicButton, buttonGroup: any[]): void {
        var i: number = 0;
        var len: number = int(buttonGroup.length);
        for (i = 0; i < len; ++i) {
            buttonGroup[i].deselected();
        }
        selectedButton.selected();
    }

    private fillItems(): void {
        var currentShopItem: number = this.currentPage * this.ITEMS_PER_PAGE;
        var filteredArray: any[] = this.getFilteredArray();
        this.initArrows(filteredArray.length);
        for (var i: number = 0; i < this.ITEMS_PER_PAGE; i++) {
            var cItem: Library.PokerInterface.PokerGiftItem = this.shopScreen.mc_shopitems["item" + i] as Library.PokerInterface.PokerGiftItem;

            if (currentShopItem < filteredArray.length) {
                this.createShopItem(filteredArray[currentShopItem], cItem);
                cItem.mouseEnabled = true;
                cItem.mouseChildren = true;
                cItem.mc_content.mouseEnabled = false;
                cItem.mc_content.mouseChildren = false;
                cItem.visible = true;
            }
            else {
                cItem.visible = false;
            }
            currentShopItem++;
        }
    }

    private createShopItem(itemVO: GiftsVO, itemHolder: Library.PokerInterface.PokerGiftItem): void {
        var itemMC: MovieClip = AvatarHelper.drawGift(itemVO);
        while (itemHolder.mc_content.mc_itemholder.numChildren > 0)
            itemHolder.mc_content.mc_itemholder.removeChildAt(0);
        itemHolder.txt_cash.text = NumberStringHelper.groupString((itemVO.priceGold > 0) ? itemVO.priceGold : this.itemPriceChips(itemVO), Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        itemHolder.mc_content.mc_gold.visible = (itemVO.priceGold > 0);
        itemHolder.mc_content.mc_chips.visible = !itemHolder.mc_content.mc_gold.visible;
        itemHolder.btn_buy.properties = itemVO.id;
        itemHolder.btn_buyall.properties = itemVO.id;
        itemHolder.btn_buy.toolTipText = Poker2Model.languageData.getTextById("table_gifts_buyOne");
        itemHolder.btn_buyall.toolTipText = Poker2Model.languageData.getTextById("table_gifts_buyAll");
        itemHolder.category = itemVO.shopCategorySecondary;
        this.itemScaleHelper(itemMC);
        itemHolder.mc_content.mc_itemholder.addChild(itemMC);
    }

    private itemPriceChips(item: GiftsVO): number {
        //			=MAX(AUFRUNDEN(LOG(SVERWEIS($U$3;Tische!$G$3:$M$150;4;FALSCH))*$U$3;0)*Q7;5)
        var tablePrice: number = Poker2Model.onTableData.currentTable.giftMultiplicator * item.priceChips;
        return MathBase.max(5, tablePrice);
    }

    private itemScaleHelper(itemMC: Container): void {
        var bounds: Rectangle = itemMC.getBounds(null);
        var scaleFactor: number = (75 / bounds.width);
        if ((bounds.height * scaleFactor) > 55)
            scaleFactor = (55 / bounds.height);
        itemMC.scaleX = itemMC.scaleY = scaleFactor;
        itemMC.x = - ((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
        itemMC.y = - ((bounds.height * scaleFactor) / 2 + (bounds.top * scaleFactor));
    }

    private getFilteredArray(): any[] {
        var result: any[] = new Array();

        var itemVO: GiftsVO;

        // TODO: ugly if/for each construction
        if (Poker2Model.eventIsActive && this.currentCategory == "events") {
            for (itemVO of Poker2Model.giftData.gifts) {
                if (itemVO.itemCategory == this.currentCategory && itemVO.availability == Poker2Model.sessionData.currentEvents[0]) {
                    result.push(Poker2Model.wodData.getItemVObyID(itemVO.id) as GiftsVO);
                }
            }
        }
        else {
            for (itemVO of Poker2Model.giftData.gifts) {
                if (itemVO.itemCategory == this.currentCategory) {
                    result.push(Poker2Model.wodData.getItemVObyID(itemVO.id) as GiftsVO);
                }
            }
        }

        result.sort(this.bindFunction(this.sortOnGifts));
        if (this.sortType == Poker2SendGiftDialog.SORT_DESCENDING)
            return result.reverse();
        else
            return result;
    }

    private sortOnGifts(a: GiftsVO, b: GiftsVO): number {
        return a.priceGold - b.priceGold || a.priceChips - b.priceChips;
    }

    protected get shopProperties(): Poker2SendGiftDialogProperties {
        return this.properties as Poker2SendGiftDialogProperties;
    }

    public get shopScreen(): Library.PokerInterface.PokerGiftShop {
        return this.disp as Library.PokerInterface.PokerGiftShop;
    }
}

import { AvatarHelper } from "../helper/AvatarHelper";
import {Poker2DynamicCombobox} from "../components/Poker2DynamicCombobox";
import {Poker2LayoutManager} from "../Poker2LayoutManager";
